import { Component, Input, OnChanges, OnInit, SimpleChanges, Type, ViewEncapsulation } from '@angular/core';
import { SliderProOptions } from 'projects/common/components/slider-pro/slider-pro.component';
import { WizumenModel } from '../../wizumen-models';
import { WizumenItemComponent } from './wizumen-item.component';
import { Device } from 'projects/common/model/Device';

@Component({
  selector: 'wizumen-slider',
  template: `
    <div class="wizumen-carousel-container">
      <div class="eva-3-carousel wizumen-carousel">
        <div class="carousel-cards-container" [attr.data-module-id]="'wizumen'">
          <div id="wizumen-carousel-container">
            <div id="wizumen-carousel-wrapper" class="wizumen-carousel-wrapper wizumen-carousel-item card-item">

              <slider-pro
                [components]="components"
                [componentParams]="componentParams"
                [options]="sliderProOptions"
                [upaData]="upaData"
              ></slider-pro>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['../../wizumen-slider.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenSliderComponent implements OnInit, OnChanges {
  @Input() device: Device;
  @Input() items: WizumenModel[];
  @Input() flow: string;
  @Input() moduleIndex: number;
  @Input() moduleId: string;
  @Input() uniqueId: string;
  @Input() isOpenDropdown: boolean;
  @Input() isTPV3Desktop: boolean;
  @Input() locale: string;
  @Input() isCollapsedByDefault: boolean;

  componentParams: any[] = [];
  components: Type<any>[] = [];
  sliderProOptions: SliderProOptions;
  upaData: any;

  constructor() { }

  ngOnInit(): void {
    this.upaData = {
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      uniqueId: this.uniqueId
    };

    this.transformModelToSliderPro();
    this.initSliderProOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes?.items?.firstChange && changes?.items?.currentValue != null) {
      this.ngOnInit();
    }
  }

  initSliderProOptions() {
    this.sliderProOptions = {
      itemsToShow: { 'DEFAULT': this.device.type != 'DESKTOP' || this.items.length == 1 || this.items[0].wizumen_v2 == true ? 1 : 3 },
      itemsToMove: { 'DEFAULT': 1 },
      dragToMove: { 'DEFAULT': this.device.type != 'DESKTOP' },
      showArrows: { 'DEFAULT': this.device.type == 'DESKTOP' },
      showDots: { 'DEFAULT': true },
      containerWidth: { 'DEFAULT': this.device.type != 'MOBILE' && this.items.length == 1 && this.items[0].wizumen_v2 == false ? '420px' : undefined }
    };
  }

  transformModelToSliderPro() {
    this.components = new Array(this.items.length).fill(WizumenItemComponent);
    this.componentParams = this.items.map((wizumenItem) => {
      return {
        item: wizumenItem,
        flow: this.flow,
        moduleIndex: this.moduleIndex,
        moduleId: this.moduleId,
        uniqueId: this.uniqueId,
        isOpenDropdown: this.isOpenDropdown,
        isTPV3Desktop: this.isTPV3Desktop,
        locale: this.locale,
        device: this.device,
        isCollapsedByDefault: this.isCollapsedByDefault
      }
    });
  }
}
